module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/live-class",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-podcast"
  }), _vm._v(" "), _c('span', [_vm._v("Live class")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff673216","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class/components/Navigation.vue
// module id = 2231
// module chunks = 1